<template>
  <div class="container">
    <div class="d-flex flex-row justify-content-center custom-row">
      <div class="col-sm-12 custom-container">
            <div class="panel-heading align-middle">
              <img class=" small-icon ml-3 mr-2"  :src="require('@/assets/icons/icon_mosaic.svg')" alt="upload" />  Subida de datos
            </div>
            <div class="panel-body">
              <form :model="form" ref="form" v-on:submit.prevent >
              <h6>Tipo de evento</h6>
              <div class="input-group">
                <select id="tipo-evento" class="custom-select" v-model="form.eventType">
                  <option value="mosaic">Mosaico fotográfico</option>
                  <option value="bathymetry">Relieve submarino</option>
                  <option value="params">Parámetros oceanográficos</option>
                  <!-- <option value="geologic">Naturaleza geológica</option> -->
                  <option value="sonar">Sónar de barrido lateral</option>
                </select>
              </div>

              <h6>Campaña</h6>
              <div class="input-group">
                <select id="campaign" class="custom-select" v-model="form.campaignId">
                  <option value="new">Nueva Campaña</option>

                    <option
                      v-for="campaign in campaigns"
                      :key="campaign.id"
                      :label="campaign.name"
                      :value="campaign.id">
                      {{ campaign.name }}
                    </option>

                </select>
              </div>
              <div v-if="form.campaignId=='new'" style="padding-left: 20px;">
                <div class="title-bold">Nombre de campaña</div>
                <div class="input-group">
                  <input type="text" class="custom-input-text" v-model="form.newCampaignName">
                </div>
                <div class="title-bold">Código</div>
                <div class="input-group">
                  <input type="text" class="custom-input-text" v-model="form.newCampaignCode">
                </div>
                <div class="title-bold">Abstract</div>
                <div class="input-group">
                  <input type="text" class="custom-input-text" v-model="form.newCampaignAbstract">
                </div>
                <div class="title-bold">Descripción</div>
                <div class="input-group">
                  <input type="text" class="custom-input-text" v-model="form.newCampaignDescription">
                </div>
                <div class="title-bold">Objetivos</div>
                <div class="input-group">
                  <input type="text" class="custom-input-text" v-model="form.newCampaignGoal">
                </div>
                <div class="title-bold">Localización</div>
                <div class="input-group">
                  <input type="text" class="custom-input-text" v-model="form.newCampaignLocation">
                </div>
              </div>

                <h6>Datos de campaña</h6>
                <div style="padding-left: 20px;">
                  <div class="title-bold">Nombre de set de datos</div>
                  <div class="input-group">
                    <input type="text" class="custom-input-text" v-model="form.campaignDataName">
                  </div>
                  <div class="title-bold">Descripción</div>
                  <div class="input-group">
                    <input type="text" class="custom-input-text" v-model="form.campaignDataDescription">
                  </div>
                  <div class="title-bold">Comentarios</div>
                  <div class="input-group">
                    <input type="text" class="custom-input-text" v-model="form.campaignDataComments">
                  </div>
                  <div class="title-bold">Fecha de medición</div>
                  <div class="input-group">
                    <input type="date" class="custom-input-text" v-model="form.campaignDataDate" required>
                  </div>
                <!-- <div class="title-bold">Responsable</div>
                <div class="input-group">
                  <select id="responsable" class="custom-select" v-model="form.campaignDataUser">
                    <option
                      v-for="user in users"
                      :key="user.id"
                      :value="user.id">
                      {{ user.first_name }} {{ user.last_name }} <span v-if="user.associate==true">({{ user.organization }})</span>
                    </option>
                  </select>
                </div> -->
                <!-- <div class="title-bold">Plataforma</div>
                <div class="input-group">
                  <select id="plataforma" class="custom-select" v-model="form.campaignDataPlatform">
                    <option
                      v-for="platform in platforms"
                      :key="platform.properties.pk"
                      :label="platform.properties.name"
                      :value="platform.properties.pk">
                      {{ platform.properties.name }}
                    </option>
                  </select>
                </div>
                <div class="title-bold">Sensor</div>
                  <div class="input-group">
                    <select id="sensor" class="custom-select" v-model="form.campaignDataSensor">
                      <option
                        v-for="sensor in sensors"
                        :key="sensor.id"
                        :label="sensor.name"
                        :value="sensor.id">
                        {{ sensor.name }}
                      </option>
                    </select>
                  </div> -->
              </div>

              <h6 v-if="form.eventType!=''">Seleccionar archivo</h6>
              <div class="input-group">
                <div v-if="form.eventType=='mosaic'" class="custom-file" id="upload-file">
                  <input type="file" class="custom-file-input" accept=".zip,.rar,.7zip,.kmz"
                    aria-describedby="inputUploadKMZ" @change="checkFileKMZ()" ref="inputUploadKMZ">
                  <label class="custom-file-label" for="inputUploadKMZ" v-html="HTMLcontentKMZ"></label><i class="float-right pic arrow-down"></i>
                </div>
                <div v-if="form.eventType=='params'" class="custom-file" id="upload-file">
                  <input type="file" class="custom-file-input" accept=".xlsx"
                    aria-describedby="inputUploadExcel" @change="checkFileExcel()" ref="inputUploadExcel">
                  <label class="custom-file-label" for="inputUploadExcel" v-html="HTMLcontentExcel"></label><i class="float-right pic arrow-down"></i>
                </div>
                <div v-if="form.eventType=='bathymetry'" class="custom-file" id="upload-file">
                  <input type="file" class="custom-file-input" accept=".csv"
                         aria-describedby="inputUploadTxt" @change="checkFileTxt()" ref="inputUploadTxt">
                  <label class="custom-file-label" for="inputUploadTxt" v-html="HTMLcontentTxt"></label><i class="float-right pic arrow-down"></i>
                </div>
                <div v-if="form.eventType=='sonar'" class="custom-file" id="upload-file">
                  <input type="file" class="custom-file-input" accept=".zip,.rar,.7zip,.kmz"
                    aria-describedby="inputUploadKMZ" @change="checkFileKMZ()" ref="inputUploadKMZ">
                  <label class="custom-file-label" for="inputUploadKMZ" v-html="HTMLcontentKMZ"></label><i class="float-right pic arrow-down"></i>
                </div>
              </div>
              <div class="input-group contenedor-btn">
                <!-- <Circle4 class="ml-auto" v-if="this.loading" ></Circle4> -->
                <pulse-loader class="ml-auto"  v-if="this.loading"  :color="spinerColor"></pulse-loader>
                <div v-else>
                  <button v-if="form.eventType=='mosaic'" class="btn-new btn-upload ml-auto" v-on:click="uploadKMZ">Subir</button>
                  <button v-if="form.eventType=='params'" class="btn-new btn-upload ml-auto" v-on:click="uploadExcel">Subir</button>
                  <button v-if="form.eventType=='bathymetry'" class="btn-new btn-upload ml-auto" v-on:click="uploadTxt">Subir</button>
                  <button v-if="form.eventType=='sonar'" class="btn-new btn-upload ml-auto" v-on:click="uploadKMZ">Subir</button>
                </div>
              </div>
              </form>
            </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getData, upload} from './../services/api'
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

  var fileName = '';
  export default {
    name: "Upload",
    components: {
      PulseLoader
    },
    data() {
      return {
        HTMLcontentKMZ: 'Seleccionar archivo KMZ<i class="float-right pic arrow-down"></i>',
        HTMLcontentExcel: 'Seleccionar archivo Excel<i class="float-right pic arrow-down"></i>',
        HTMLcontentTxt: 'Seleccionar archivo CSV<i class="float-right pic arrow-down"></i>',
      KMZfile:null,
      Excelfile:null,
      Txtfile: null,
      fileName:null,
      loading: false,
      spinerColor: '#00a7e1',

      users: [],
      campaigns: [],
      sensors: [],
      platforms: [],
      form: {
        campaignId: null,
        eventType: '',

        newCampaignName: '',
        newCampaignCode: '',
        newCampaignAbstract: '',
        newCampaignDescription: '',
        newCampaignGoal: '',
        newCampaignLocation: '',

        campaignDataName: '',
        campaignDataSensor: 1,
        campaignDataPlatform: 2,
        campaignDataDescription: '',
        campaignDataComments: '',
        campaignDataDate: '',
        campaignDataUser: 1,
      },
    };
  },
  mounted () {
    // this.getUserList()
    this.getCampaignList()
    this.getPlatformList()
    this.getSensorList()
  },
  methods: {
    getUserList: function () {
      var url = 'administration/organization-users/'
      getData(url).then(res=> {
        this.users=res.data.users
      })
    },
    getCampaignList: function () {
      var url = 'campaign/organization-campaigns/'
      getData(url).then(res=> {
        this.campaigns=res.data.campaigns
      })
    },
    getPlatformList: function () {
      var url = 'campaign/platforms/'
      getData(url).then(res=> {
        this.platforms=res.data.platforms
      })
    },
    getSensorList: function () {
      var url = 'campaign/sensors/'
      getData(url).then(res=> {
        this.sensors=res.data.sensors
      })
    },
    checkFileKMZ: function (event) {
      this.KMZfile = this.$refs.inputUploadKMZ.files[0]
      this.HTMLcontentKMZ=this.KMZfile.name
    },
    checkFileExcel: function (event) {
      this.Excelfile = this.$refs.inputUploadExcel.files[0]
      this.HTMLcontentExcel=this.Excelfile.name
    },
    checkFileTxt: function (event) {
      this.Txtfile = this.$refs.inputUploadTxt.files[0]
      this.HTMLcontentTxt = this.Txtfile.name
    },
    uploadKMZ: function () {
      if(this.KMZfile){
        this.loading = true
        this.$noty.show("La subida puede tardar hasta un minuto")
        upload(this.form, this.KMZfile).then(res => {
          this.$noty.success("Subido con éxito")
          this.loading = false
          this.resetForm()
          this.getCampaignList()
        })
          .catch(error => {
            this.$noty.error(error.request.response)
            this.loading = false
            this.getCampaignList()
          })
      }else {
        this.$noty.error("Añade un archivo valido primero")
      }
    },
    uploadExcel: function () {
      if(this.Excelfile){
        this.loading = true
        this.$noty.show("La subida puede tardar hasta un minuto")
        
        upload(this.form, this.Excelfile).then(res => {
          this.$noty.success("Subido con éxito")
          this.loading = false
          this.resetForm()
          this.getCampaignList()
        })
          .catch(error => {
            this.$noty.error(error.request.responseText)
            this.loading = false
            this.getCampaignList()
          })
      }else{
        this.$noty.error("Añade un archivo valido primero")
      }
    },
    uploadTxt: function () {
      if (this.Txtfile) {
        this.loading = true
        this.$noty.show("La subida puede tardar hasta un minuto")
        upload(this.form, this.Txtfile).then(res => {
          this.loading = false
          this.resetForm()
          this.$noty.success("Subido con éxito")
          this.getCampaignList()
        })
        .catch(error => {
          this.$noty.error(error.request.response)
          this.loading = false
          this.getCampaignList()
        })
      }else{
        this.$noty.error("Añade un archivo valido primero")
      }
    },
    resetForm: function () {
      this.form.campaignId = null
      this.form.eventType = ''
      this.form.newCampaignName = ''
      this.form.newCampaignCode = ''
      this.form.newCampaignAbstract = ''
      this.form.newCampaignDescription = ''
      this.form.newCampaignGoal = ''
      this.form.newCampaignLocation = ''
      this.form.campaignDataName = ''
      //this.form.campaignDataSensor = 1
      //this.form.campaignDataPlatform = 2
      this.form.campaignDataDescription = ''
      this.form.campaignDataComments = ''
      this.form.campaignDataDate = ''
      //this.form.campaignDataUser = 1
      
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  .mosaic-icon{
    width:18px;
    margin:5px;
  }

  .pic {
    margin-right: 15px;/* demo spacing */
    display: inline-block;
    vertical-align: middle;
    width: 0;
    height: 0;
    z-index:100;
  }

  .arrow-down {
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 8px solid #cacccc;
  }

  #upload-file > .custom-file-label{
    background-color: #f9f9f9;
    font-size:12px;
    cursor:pointer !important;
  }

  .custom-file-input ~ .custom-file-label::after {
    display:none;
    cursor:pointer !important;
  }

  .contenedor-btn{
    padding-top:10px;
    justify-content: end;
  }

  .btn-upload{
    width:100px;
  }
  .custom-select{
    background-color: #f9f9f9;
    font-size:12px;
    cursor:pointer !important;
  }
  .input-group{
    margin-bottom: 20px;
  }
  .custom-input-text{
    background-color: #f9f9f9;
    font-size: 12px;
    width: 100%;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: .375rem 1.75rem .375rem .75rem;
  }
  .title-bold{
    font-size:small;
    font-weight: 600;
  }
  .separator{
    height: 1px;
    background-color: #ccc;
    margin: 10px 0px;
  }
  .container{
    height: 100%;
    padding-bottom: 116px;
  }
  .custom-row{
    height:100%;
  }
  .custom-container{
    box-shadow: 0px 2px 5px grey;
    padding:0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }
  .panel-heading{
    padding:20px 10px 10px 10px;
    background-color:#edefef;
    /*border-bottom: 1px solid #c6c6c8;*/
  }
  .panel-heading > p{
    margin:0;
    /* font-size: */
  }
  .panel-body{
    padding:30px;
    background-color:#ffffff;
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/Upload.vue